import { Box } from '@mui/material';
import { Modal as MuiModal } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { TUTORIAL_VIDEO_Z_INDEX } from 'Constants/StackingLevels';
import { narrationVideoCrossOrigin } from 'Volume/videoNarrationGain';
import { useHardwareBackClosesLayer } from 'Hooks/useHardwareBack';

export const TUTORIAL_VIDEO_URL =
  'https://assets.museflow.ai/videos/game-tutorials/sight-reading-trainer-tutorial.mov';

type TutorialVideoModalProps = {
  open: boolean;
  onClose: () => void;
  // The video's voice is the narration channel (MUS-87): the lesson sets its volume and mute.
  videoRef?: (video: HTMLVideoElement | null) => void;
  muted?: boolean;
};

const TutorialVideoModal = ({
  open,
  onClose,
  videoRef,
  muted = false,
}: TutorialVideoModalProps) => {
  // Android's Back closes the video as its X does.
  useHardwareBackClosesLayer(open, onClose, TUTORIAL_VIDEO_Z_INDEX);
  return (
    <MuiModal
      open={open}
      sx={{
        // height: 'auto',
        width: 'min(1000px, 94vw)',
        minWidth: 320,
        minHeight: 200,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        background: 'black',
        height: '600px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        maxHeight: '80vh',
        zIndex: TUTORIAL_VIDEO_Z_INDEX,
        // padding: '20px'
      }}
    >
      <>
        <Box sx={{ position: 'absolute', top: 5, right: 12 }}>
          <IconButton aria-label="Close video" onClick={onClose} sx={{ color: '#CED0D4' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box sx={{ width: '100%' }}>
            <video
              ref={videoRef}
              style={{ width: '100%', maxHeight: '70vh', borderRadius: 8 }}
              controls
              autoPlay
              muted={muted}
              // On iOS the narration volume plays through Web Audio, which needs CORS.
              crossOrigin={narrationVideoCrossOrigin()}
              playsInline
            >
              <source src={TUTORIAL_VIDEO_URL} />
              Your browser does not support the video tag.
            </video>
          </Box>
        </Box>
      </>
    </MuiModal>
  );
};

export default TutorialVideoModal;
